:host {
    display: flex;
    flex-flow: wrap;
    align-items: stretch;
    gap: 20px;
}
